/**
 * F1 — useFeature hook
 *
 * Használat:
 *   const { active, loading } = useFeature('projektek');
 *   if (!active) return <LockedFeature feature="projektek" />;
 *
 * A FeatureProvider-ből olvassa az adatot — nincs külön API hívás.
 */
import { useFeatureContext, type FeatureName } from '../contexts/FeatureContext';

export interface UseFeatureResult {
  /** A feature elérhető-e a tenant jelenlegi csomagjában */
  active: boolean;
  /** Még töltés alatt van-e a feature-lista */
  loading: boolean;
  /** Az aktuális előfizetési szint (start/standard/pro/enterprise) */
  planCode: string;
  /** Az előfizetés állapota (trial/active/read_only/locked/cancelled) */
  status: string;
  /** Trial lejárata (null ha nem trial) */
  trialEndsAt: string | null;
}

export function useFeature(feature: FeatureName): UseFeatureResult {
  const { activeFeatures, planCode, status, trialEndsAt, loading } = useFeatureContext();
  return {
    active: loading ? true : activeFeatures.includes(feature),
    loading,
    planCode,
    status,
    trialEndsAt,
  };
}
